export default "__VITE_ASSET__Dpia7j9m__"